import { MinimumStationsGroup } from '@app/core/types/stations';
import { stationsStationsGroupsGetQueryKey, useStationsStationsGroupsGet } from '@mi-front/api-v2';

/**
 * Loads a single station group by id or slug via api-v2.
 * Casts to MinimumStationsGroup (OpenAPI stations payload is incomplete).
 */
export function useStationGroupQuery(stationGroupId: string) {
  return useStationsStationsGroupsGet<MinimumStationsGroup>(stationGroupId, {
    query: {
      select: (data) => data as unknown as MinimumStationsGroup,
    },
  });
}

useStationGroupQuery.queryKey = stationsStationsGroupsGetQueryKey;
